// core
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';

// campfire
import { MatDialog } from '@campfire-nx/material';
import { PdsService, PortalOneHandoverService } from '@campfire-nx/api';
import { PartnerBrandService } from '@campfire-nx/api';
import { RaptorDataService, IArrangementFeeBanner } from 'libs/raptor/src/lib/services/raptor-data.service';

// services

// components
import { AhmComparisonModalComponent } from '../modals/ahm-comparison-modal/ahm-comparison-modal.component';

// environment
import { environment } from '@open-portal-env';


@Component({
  selector: 'app-refer-ahm',
  templateUrl: './refer-ahm.component.html',
  styleUrls: ['./refer-ahm.component.scss']
})
export class ReferAhmComponent implements OnInit {
  @Input() quote!: any;
  reference!: any;
  cover!: any;
  price: any = {
    currency: '$',
    amount: 0,
    frequency: 'year'
  };
  precision: number = 2;
  vehicle!: string;
  pds!: any;
  tmd!: any;
  roadsideTermsConditions!: any;
  apiEndpoint = environment.apiEndpoint;
  arrangementFeeBanner: IArrangementFeeBanner | null = null;
  additionalChargesDisclaimers: Array<any> = [];

  constructor(
    private route: ActivatedRoute,
    private portalOneHandoverService: PortalOneHandoverService,
    private pdsService: PdsService,
    private raptorDataService: RaptorDataService,
    private partnerBrandService: PartnerBrandService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.data.reference) {
      this.reference = this.route.snapshot.data.reference;
      this.quote = this.formatQuote(this.reference.quote);
      this.vehicle = [
        this.quote.human.vehicle.model,
        this.quote.human.vehicle.description,
        this.quote.human.vehicle.variant,
        this.quote.human.vehicle.series,
        this.quote.human.vehicle.transmission
      ].join(' - ');

      this.pdsService.history(this.quote.data.product_slug)
        .then((response: any) => {
          if (response[this.quote.data.product_slug]) {
            let pdsArray = response[this.quote.data.product_slug].filter((file: any) => { return file.type === 'pds'});
            let pds = pdsArray.sort((a: any, b: any) => {
              return moment(a.start_date) < moment(b.start_date) ? 1 : -1;
            })[0];
            this.pds = pds;
          }

          if (response[this.quote.data.product_slug]) {
            let tmdArray = response[this.quote.data.product_slug].filter((file: any) => { return file.type === 'targetmarketdetermination'});
            let tmd = tmdArray.sort((a: any, b: any) => {
              return moment(a.start_date) < moment(b.start_date) ? 1 : -1;
            })[0];
            this.tmd = tmd;
          }

          if (response[this.quote.data.product_slug]) {
            let roadsideTermsConditionsArray = response[this.quote.data.product_slug].filter((file: any) => { return file.type === 'supplementary' && file.name.toLowerCase().includes('roadside')});
            let ratc = roadsideTermsConditionsArray.sort((a: any, b: any) => {
              return moment(a.start_date) < moment(b.start_date) ? 1 : -1;
            })[0];
            this.roadsideTermsConditions = ratc;
          }
        })

        if (this.quote.covers && this.quote.covers[0].has_additional_charges) {
          this.getPolicyArrangementBannerDisclaimer();
        }
    }
  }

  formatQuote(quote: any) {
    this.calculateTotalPayable(quote)
    return quote;
  }

  calculateTotalPayable(quote: any) : void {
    let selectedCover;
    let product_slug = quote.data['product_slug'];
    let cover_type = quote.data['cover_type'];
    let cover_level = quote.data['cover_level'];
    let frequency = quote.data['frequency'];

    if (quote.covers && Array.isArray(quote.covers)) {
      selectedCover = quote.covers.find((coverItem: any) => {
        return coverItem.cover.product_slug === product_slug &&
          coverItem.cover.cover_type === cover_type &&
          coverItem.cover.cover_level === cover_level
      });
    }

    if (selectedCover) {
      let premiumAttr = 'payable';

      if (frequency === 'U') {
        this.price.frequency = 'year';
        premiumAttr = 'payable';
      }
      if (frequency === 'M') {
        this.price.frequency = 'month';
        premiumAttr = 'payable_monthly';
      }
      this.price.amount = selectedCover.premium[frequency] && selectedCover.premium[frequency][premiumAttr];
    }
    this.price.currency = this.partnerBrandService.getCurrencySymbol();
  }

  public bookAppointment() {
    this.portalOneHandoverService.bookAppointment(this.reference.product.class + '-quote', this.quote, this.reference.partner);
  }

  public showComparison() {
    this.dialog.open(AhmComparisonModalComponent, {
      width: '100%',
      height: '100%',
      maxHeight: '90vh',
      data: {
        pds: this.pds,
        tmd: this.tmd,
        apiEndpoint: this.apiEndpoint
      }
    });
  }

  getPolicyArrangementBannerDisclaimer(): any {
    const { frequency } = this.quote.data;
    const { premium } = this.quote.covers[0];
    const disclaimers = this.raptorDataService.mapBannerDisclaimers(this.quote.covers);

    this.additionalChargesDisclaimers = this.raptorDataService.getIncludedExtrasDisclaimers(premium[frequency].extras);
    this.arrangementFeeBanner = this.raptorDataService.getArrangementFeeBanner(premium, disclaimers, frequency, false);
  }
}